export enum ExcelExportModuleType {
    Jobs = 0,
    Timesheets = 1,
    Invoices = 2,
    Users = 3,
    Businesses = 4,
}